/**
 * Tiny logger util — mute debug-level messages in production builds so
 * they don't clutter the browser console for end-users. `warn` and `error`
 * remain visible so operators / support staff can still see anomalies that
 * matter.
 *
 * Usage: `import { logger } from "@/lib/logger";`
 */
const isDev =
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV !== "production";

export const logger = {
  debug: (...args) => {
    if (isDev) console.debug(...args);
  },
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default logger;
